import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'

const CheckboxField = ({ name, displayName, disabled, value, onChange, onClick }) => {

  return (
    <label className="checkbox-field-container">
      <input
        id={name}
        name={name}
        type="checkbox"
        checked={(value === 'true' || value === true) ? true : false}
        onChange={onChange ? (e) => onChange(e.target.checked, e) : () => {}}
        disabled={disabled}
        onClick={onClick ? onClick : () => {}}
      />
      <span className="checkmark"></span>
      {!displayName || <label className='display-name-label' htmlFor={name}>{displayName}</label>}
    </label>
  )
}

CheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default CheckboxField
